module.exports = ".panel-ndw {\n  border-color: #f27e24; }\n\n.panel-ndw > .panel-heading {\n  color: #753707;\n  background-color: #f38c3c;\n  border-color: #f27e24; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/comments/siterecord-comment.component.scss
// module id = ./src/app/shared/comments/siterecord-comment.component.scss
// module chunks = main